module.exports = __webpack_public_path__ + "static/media/mouse.08bc649f.svg";